import type { FaireProductEntity } from "../../entity_types/product";

export const p_smx6jjfhnr: FaireProductEntity = {
  token: "p_smx6jjfhnr",
  type: "product",
  name: "Ashwagandha + Chill - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/499f38a3236299fe3524085df3e9333af063a23264363354a86b5c3aceed75d3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/96a0b3b3ec93f620d7d74ca21177ce9ec228b9bda5c3d7f1698248db0dce9ad7.png",
    "https://cdn.faire.com/fastly/f3b50d82ac119416a660c9808967c340ec82acfe846660d5dbfe41ef3c182bb3.jpeg",
    "https://cdn.faire.com/fastly/7099cd2650f5caa8819d29820422f0d66114ef79a843e1612797a6cc1174a1fc.jpeg",
    "https://cdn.faire.com/fastly/1e5e5e8e603b00f79ec6a8d31fa2e0de594f886f2277ae45bd3f3c7b6d799f80.jpeg",
    "https://cdn.faire.com/fastly/84915236876288424419ed8d52bec2f32d83928aa7547a9ebf045f71d0db7854.jpeg"
  ],
  priceDollars: 7.45,
  description: "SUPERFOOD TEA BLEND \n\nSteep, sip, and slow down. Ashwagandha, passionflower, and chamomile make up this blissful herbal tea blend, with powers to provide instant relaxation with every sip. Sip daily to de-stress, or enjoy as a night cap to unwind and prepare for your best sleep ever. \n\n100% ORGANIC - ADAPTOGENIC - NUTRITIONIST FORMULATED\n\nHow to Enjoy:\n\n * Steep tea in 1 cup of 98° water for 4-6 minutes. \n * Try me with a splash of milk and honey. \n * Tea Latte: Steep tea double strength and top with frothed milk, vanilla and sweetener. \nWhen to Steep:\n\n\n * A soothing all day caffeine-free tea \n * To calm your nerves and promote calmness and clarity. \n * To boost immunity and reduce inflammation with superfoods \n * To aid in sleep before bed. \n*Caffeine-free\n",
  tags: [],
  msrpDollars: 13.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:40.014Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
